import React from 'react'

const LuxuryCarsData =  [
{
    id: 1,
    carName: 'ROLLS-ROYCE',
    price: '$3640',
    carImage: 'images/luxury/1.png',
},
{
    id: 2,
    carName: 'BENTLEY',
    price: '$3640',
    carImage: 'images/luxury/2.png',
},
{
    id: 3,
    carName: 'BENTLEY',
    price: '$3640',
    carImage: 'images/luxury/3.png',
},
{
    id: 4,
    carName: 'BENTLEY',
    price: '$3640',
    carImage: 'images/luxury/4.png',
},
{
    id: 5,
    carName: 'BENTLEY',
    price: '$3640',
    carImage: 'images/luxury/5.png',
},
{
    id: 6,
    carName: 'BENTLEY',
    price: '$3640',
    carImage: 'images/luxury/6.png',
},
{
    id: 7,
    carName: 'BENTLEY',
    price: '$3640',
    carImage: 'images/luxury/7.png',
},
{
    id: 8,
    carName: 'BENTLEY',
    price: '$3640',
    carImage: 'images/luxury/8.png',
},
{
    id: 9,
    carName: 'BENTLEY',
    price: '$3640',
    carImage: 'images/luxury/9.png',
},

]
export default LuxuryCarsData